"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ReceiveSlotManager = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _internalMediaCore = require("@webex/internal-media-core");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _receiveSlot = require("./receiveSlot");
/* eslint-disable valid-jsdoc */
/* eslint-disable import/prefer-default-export */
/**
 * Manages all receive slots used by a meeting. WMCE receive slots cannot be ever deleted,
 * so this manager has a pool in order to re-use the slots that were released earlier.
 */
var ReceiveSlotManager = exports.ReceiveSlotManager = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param {Meeting} meeting
   */
  function ReceiveSlotManager(createSlotCallback, findMemberIdByCsiCallback) {
    (0, _classCallCheck2.default)(this, ReceiveSlotManager);
    (0, _defineProperty2.default)(this, "allocatedSlots", void 0);
    (0, _defineProperty2.default)(this, "freeSlots", void 0);
    (0, _defineProperty2.default)(this, "createSlotCallback", void 0);
    (0, _defineProperty2.default)(this, "findMemberIdByCsiCallback", void 0);
    this.allocatedSlots = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, _internalMediaCore.MediaType.AudioMain, []), _internalMediaCore.MediaType.VideoMain, []), _internalMediaCore.MediaType.AudioSlides, []), _internalMediaCore.MediaType.VideoSlides, []);
    this.freeSlots = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, _internalMediaCore.MediaType.AudioMain, []), _internalMediaCore.MediaType.VideoMain, []), _internalMediaCore.MediaType.AudioSlides, []), _internalMediaCore.MediaType.VideoSlides, []);
    this.createSlotCallback = createSlotCallback;
    this.findMemberIdByCsiCallback = findMemberIdByCsiCallback;
  }

  /**
   * Creates a new receive slot or returns one from the existing pool of free slots
   *
   * @param {MediaType} mediaType
   * @returns {Promise<ReceiveSlot>}
   */
  (0, _createClass2.default)(ReceiveSlotManager, [{
    key: "allocateSlot",
    value: (function () {
      var _allocateSlot = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(mediaType) {
        var availableSlot, wcmeReceiveSlot, receiveSlot;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // try to use one of the free ones
              availableSlot = this.freeSlots[mediaType].pop();
              if (!availableSlot) {
                _context.next = 5;
                break;
              }
              this.allocatedSlots[mediaType].push(availableSlot);
              _loggerProxy.default.logger.log("".concat(mediaType, ": receive slot re-used: ").concat(availableSlot.id));
              return _context.abrupt("return", availableSlot);
            case 5:
              _context.next = 7;
              return this.createSlotCallback(mediaType);
            case 7:
              wcmeReceiveSlot = _context.sent;
              receiveSlot = new _receiveSlot.ReceiveSlot(mediaType, wcmeReceiveSlot, this.findMemberIdByCsiCallback);
              this.allocatedSlots[mediaType].push(receiveSlot);
              _loggerProxy.default.logger.log("".concat(mediaType, ": new receive slot allocated: ").concat(receiveSlot.id));
              return _context.abrupt("return", receiveSlot);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function allocateSlot(_x) {
        return _allocateSlot.apply(this, arguments);
      }
      return allocateSlot;
    }()
    /**
     * Releases the slot back to the pool so it can be re-used by others in the future
     * @param {ReceiveSlot} slot
     */
    )
  }, {
    key: "releaseSlot",
    value: function releaseSlot(slot) {
      var idx = this.allocatedSlots[slot.mediaType].findIndex(function (allocatedSlot) {
        return allocatedSlot === slot;
      });
      if (idx >= 0) {
        this.allocatedSlots[slot.mediaType].splice(idx, 1);
        this.freeSlots[slot.mediaType].push(slot);
        _loggerProxy.default.logger.log("".concat(slot.mediaType, ": receive slot released: ").concat(slot.id));
      } else {
        _loggerProxy.default.logger.warn("ReceiveSlotManager#releaseSlot --> trying to release a ".concat(slot.mediaType, "} slot that is not managed by this ReceiveSlotManager"));
      }
    }

    /**
     * Resets the slot manager - this method should be called when the media connection is torn down
     */
  }, {
    key: "reset",
    value: function reset() {
      this.allocatedSlots = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, _internalMediaCore.MediaType.AudioMain, []), _internalMediaCore.MediaType.VideoMain, []), _internalMediaCore.MediaType.AudioSlides, []), _internalMediaCore.MediaType.VideoSlides, []);
      this.freeSlots = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, _internalMediaCore.MediaType.AudioMain, []), _internalMediaCore.MediaType.VideoMain, []), _internalMediaCore.MediaType.AudioSlides, []), _internalMediaCore.MediaType.VideoSlides, []);
    }

    /**
     * Returns statistics about the managed slots
     *
     * @returns {Object}
     */
  }, {
    key: "getStats",
    value: function getStats() {
      var _this = this;
      var numAllocatedSlots = {};
      var numFreeSlots = {};
      (0, _keys.default)(this.allocatedSlots).forEach(function (key) {
        if (_this.allocatedSlots[key].length > 0) {
          numAllocatedSlots[key] = _this.allocatedSlots[key].length;
        }
      });
      (0, _keys.default)(this.freeSlots).forEach(function (key) {
        if (_this.freeSlots[key].length > 0) {
          numFreeSlots[key] = _this.freeSlots[key].length;
        }
      });
      return {
        numAllocatedSlots: numAllocatedSlots,
        numFreeSlots: numFreeSlots
      };
    }

    /**
     * Tries to find the member id on all allocated receive slots
     * This function should be called when new members are added to the meeting.
     */
  }, {
    key: "updateMemberIds",
    value: function updateMemberIds() {
      var _this2 = this;
      (0, _keys.default)(this.allocatedSlots).forEach(function (key) {
        _this2.allocatedSlots[key].forEach(function (slot) {
          slot.findMemberId();
        });
      });
    }

    /**
     * Find a receive slot by a ssrc.
     *
     * @param ssrc - The ssrc of the receive slot to find.
     * @returns - The receive slot with this ssrc, undefined if not found.
     */
  }, {
    key: "findReceiveSlotBySsrc",
    value: function findReceiveSlotBySsrc(ssrc) {
      return (0, _values.default)(this.allocatedSlots).flat().find(function (r) {
        var _r$wcmeReceiveSlot, _r$wcmeReceiveSlot$id;
        return ssrc && ((_r$wcmeReceiveSlot = r.wcmeReceiveSlot) === null || _r$wcmeReceiveSlot === void 0 ? void 0 : (_r$wcmeReceiveSlot$id = _r$wcmeReceiveSlot.id) === null || _r$wcmeReceiveSlot$id === void 0 ? void 0 : _r$wcmeReceiveSlot$id.ssrc) === ssrc;
      });
    }
  }]);
  return ReceiveSlotManager;
}();
//# sourceMappingURL=receiveSlotManager.js.map
